import noop from "lodash/noop";
import pick from "lodash/pick";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import { useUser } from "../../../utils/hooks/user";
import { useMyRequests } from "../api";
import Form from "./Form";

const AddPayCode = ({
    user: predefinedUser,
    isOpen,
    onSuccess = noop,
    onFailure = noop,
    onClose = noop,
}) => {
    const { t } = useTranslation();
    const { create, loading, error } = useMyRequests();
    const user = useUser();

    const onFinish = useCallback(
        (data) => {
            const request = {
                user: user.id,
                type: "pay-code-escalation",
                namespace: "timesheet",
                data,
                ...pick(data, ['level1', 'level2', 'level3', 'level4']),
            };
            create(request, (request) => {
                onClose();
                onSuccess?.(request);
                toast.success(t("request-created-successfully"));
            });
        },
        [user, create, onClose, onSuccess, t]
    );

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            title={t("add-pay-code-request")}
            centered
            scrollable
            size="lg"
        >
            <Form
                onFinish={onFinish}
                onClose={onClose}
                error={error}
                loading={loading}
                user={predefinedUser}
            />
        </Modal>
    );
};

export default AddPayCode;
